

























































import { Component } from 'vue-property-decorator'
import { checkMobile } from '../../utils/utils'
import ProgressRotate from '../atoms_molecules/ProgressRotate.vue'
import { ROUTER_NAME } from '../../router'
import { LETTER_FORMAT } from '../../utils/constants'
import { mixins } from 'vue-class-component'
import ExamMixin from '../organisms/ExamMixin'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import { examTestState } from '../../stores/exam_test'
import { userState } from '../../stores/user'
import { examMyState } from '../../stores/exam_my'
import Exam from '../../models/exam'
import { PageModeType } from '../../types'
import ExamComponent from '../organisms/Exam.vue'
import SubPage from '../atoms_molecules/SubPage.vue'

@Component({
  components: {
    ProgressRotate,
    ExamComponent,
    SubPage,
  }
})
export default class ExamShow extends mixins(ExamMixin) {
  get allExams() {
    return examMyState.list
  }

  get exam() {
    return examTestState.exam
  }
  get redirectNotFoundPage() {
    return examTestState.redirectNotFoundPage
  }
  get userExam() {

    if (!this.userExamId) {
      return this.exam!.userExam
    }

    const userExam = this.exam!.userExams.find(item => item.id == parseInt(this.userExamId as string))
    return userExam
  }

  get userExamId() {
    return this.$route.query['user_exam_id']
  }

  get schoolSetting() {
    return headerState.schoolSetting
  }

  get headerNavTextColor() {
    if (this.schoolSetting) {
      return this.schoolSetting.navTextColor
    }
  }

  get user() {
    return userState.user
  }

  toExamList() {
    if (this.user.isGuestExamOnly) {
      location.href = `/exams/${this.$route.params.examId}`
      return
    }

    this.$router.push({
      name: ROUTER_NAME.MY_EXAM_LIST
    })
  }

  reRender: string = Date().toString()
  LETTER_FORMAT = LETTER_FORMAT
  mobile: boolean = false

  footerMobile = {
    color: '#7DD420',
    show: true,
    default: {
      show: false
    },
    buttons: {
      show: true,
      items: []
    }
  }

  redirectToNotFoundPage() {
    this.$router.push({
      name: ROUTER_NAME.NOT_FOUND
    })
  }

  async fetchExams() {
    await examMyState.getMyExams()

    if (this.$route.query['exam_id']) {
      const found = examMyState.list.find(item => item.id.toString() === this.$route.query['exam_id'])
      if (found) {
        this.onShowHistories(found)
      }
    }
  }

  pageMode: PageModeType = 'main_page'
  subPageExam: Exam | null = null
  onSwitchMode(pageMode: PageModeType) {
    this.pageMode = pageMode
    this.$router.push({
      query: {
        ...this.$route.query ?? {},
        exam_id: undefined
      }
    })
  }
  onShowHistories(exam: Exam) {
    this.pageMode = 'sub_page'
    this.subPageExam = exam
    this.$router.push({
      query: {
        ...this.$route.query ?? {},
        exam_id: exam.id.toString()
      }
    })
  }

  public mounted() {
    this.fetchExams()
    examTestState.requestExamTest(parseInt(this.$route.params.examId)).then(() => {
      headerState.setTitle(this.exam!.name)
    })
    this.mobile = checkMobile()
    if (this.mobile) {
      footerState.setFooter(this.footerMobile)
    } else {
      footerState.setFooterDefault()
    }
  }
}
